import React from 'react';
import ButtonAction from '../../../_common/components/ButtonAction';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import PopupDeletePriceQuote from '../PopupDeletePriceQuote/PopupDeletePriceQuote';
import {usePriceQuotesPageContext} from '../PriceQuotesPageContext';
import ButtonDD from "../../../_common/components/ButtonDD";
import PopupCreateOrder from "../PopupCreateOrder/PopupCreateOrder";
import {PopupCreateOrderProvider} from "../PopupCreateOrderContext";

export function PriceQuotesActionsColumnFormatter(cellContent, {history}) {
  const {setShowLinkModal, setLinkPriceQuoteID} = usePriceQuotesPageContext();
  const {priceQuoteID, orderID, lines} = cellContent;
  const handleEditPriceQuote = () => {
    history.push(`/price-quote-details/${priceQuoteID}`);
  };
  const handleShowSendEmailHistory = () => {
    history.push(`/notifications-page?docID=${priceQuoteID}`);
  };
  const gotLines = Array.isArray(lines) ? lines.length > 0 : false;

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{itemContent: (
              <div className="d-flex justify-content-between align-items-center">
                <ButtonAction
                  variant={'icon'}
                  iconButtonType={'warning'}
                  title={TTS.PRICE_QUOTE_CREATE_CUSTOMER_LINK}
                  disabled={!can(T.FULL, S.PRICE_QUOTES_PAGE) || cellContent.priceQuoteStatusID === 3 || !gotLines}
                  onClick={() => {
                    setShowLinkModal(true);
                    setLinkPriceQuoteID(cellContent?.priceQuoteID);
                  }}
                  label={<img src={toAbsoluteUrl('media/common/Link_yellow.svg')} alt="link" height={20}/>}
                  customClassnames={'mx-2'}
                />
                <ButtonAction
                  variant={'icon'}
                  iconButtonType={'primary'}
                  title={TTS.EDIT_PRICE_QUOTE}
                  disabled={!can(T.FULL, S.PRICE_QUOTES_PAGE)}
                  onClick={() => handleEditPriceQuote()}
                  label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="edit"/>}
                  customClassnames={'mx-2'}
                />
                <PopupDeletePriceQuote data={cellContent}/>
                <PopupCreateOrderProvider cellContent={cellContent}>
                  <PopupCreateOrder orderID={orderID}/>
                </PopupCreateOrderProvider>
                <ButtonAction
                  variant={'icon'}
                  iconButtonType={'success'}
                  title={TTS.SHOW_EMAILS_HISTORY}
                  disabled={!can(T.FULL, S.PRICE_QUOTES_PAGE) || !gotLines}
                  onClick={() => handleShowSendEmailHistory()}
                  label={<img
                    src={toAbsoluteUrl('media/common/Email-clock_green.svg')}
                    className={'h-30px'} alt={'redirect'}/>}
                  customClassnames={'mx-2'}
                />
              </div>
            )}
        ]}
      />
    </div>
  );
}